<template>
  <div>
    <huge-screen></huge-screen>
    <div class="center_container news_wrapper" >
      <div class="md-layout md-gutter md-alignment-center align-items_unset">
        <div class="md-layout-item md-size-66 md-medium-size-66 md-small-size-66 md-xsmall-size-66">
          <md-card>
            <md-ripple>

              <md-card-content>
                <p class="title">{{newData.title}}</p>
                <div class="info">
                  <span class="info-item">发布时间：{{formatTime(newData.ctime,'Y/M/D h:m:s')}}</span>
                  <span class="info-item">点击数：{{newData.view_num}}</span>
                </div>
                <div v-html="newData.news">

                </div>
              </md-card-content>
            </md-ripple>
          </md-card>
        </div>
        <div class="md-layout-item md-size-33 md-medium-size-33 md-small-size-33 md-xsmall-size-33">
          <Travel></Travel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HugeScreen from '@/components/HugeScreen/index'
import Travel from '@/views/travel/Travel'
import {getNewById} from '@/api/news'
export default {
  components: {
    HugeScreen,
    Travel
  },
  data(){
    return {
      id: '',
      newData:{
        title:'11111',
        ctime:'',
        view_num:'',
        news:''
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    /**
     * 时间戳转化为年 月 日 时 分 秒
     * number: 传入时间戳
     * format：返回格式，支持自定义，但参数必须与formateArr里保持一致
     */

    formatTime(number, format) {
      var formateArr = ["Y", "M", "D", "h", "m", "s"];
      var returnArr = [];

      var date = new Date(number * 1000);
      returnArr.push(date.getFullYear());
      returnArr.push(this.formatNumber(date.getMonth() + 1));
      returnArr.push(this.formatNumber(date.getDate()));

      returnArr.push(this.formatNumber(date.getHours()));
      returnArr.push(this.formatNumber(date.getMinutes()));
      returnArr.push(this.formatNumber(date.getSeconds()));

      for (var i in returnArr) {
        format = format.replace(formateArr[i], returnArr[i]);
      }
      return format;
    },

    //数据转化
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    },
    initData() {
      this.id = this.$route.query.newId
      this.setNewData()
    },
    setNewData() {
      if (this.$store.getters.getNewById(this.id)) {
        this.newData = this.$store.getters.getNewById(this.id)
      }
      else{
        getNewById(66,this.id).then(response=>{
          this.newData = response.data
        })
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.center_container {
  margin: 0 auto;
  width: 1120px;
}
.align-items_unset {
  align-items: unset !important;
}
.news_wrapper {
  text-align: left;
  padding-bottom: 100px;
  margin-top: 20px;
  .info {
    margin: 20px 0;
    font-size: 12px;
    color: #aaa;
    .info-item{
      margin-right: 8px;
    }
  }
  .title {
    line-height: 35px;
    padding: 5px 0 10px 0;
    border-bottom: 1px solid #e5e5e5;
    font-size: 25px;
    color: #555;
  }
}
</style>
